import { GetterTree } from "vuex";
import { RootState } from "../types";
import { DevicesState, ServerType } from "./types";

export const getters: GetterTree<DevicesState, RootState> = {
    getSortedServerTypes(state) {
        const serverTypes = state.serverTypes ? [...state.serverTypes] : [];
		return serverTypes.sort(({ title: a }, { title: b }) => {
			if (a < b) return -1;

			return b < a ? 1 : 0
		});
	},
	syncIsParentDeviceSync(state): boolean {
		try {
			const serverType: ServerType = state.serverTypes.find(
				st => st.serverTypeID === state.currentServer.serverTypeID
			);

			return serverType && serverType.isParentable && serverType.childServerTypeId != null;
		}
		catch (err) {
			return false;
		}
	},
	syncIsParentable(state): boolean {
		try {
			const serverType: ServerType = state.serverTypes.find(
				st => st.serverTypeID === state.currentServer.serverTypeID
			);

			return serverType && serverType.isParentable;
		}
		catch (err) {
			return false;
		}
	}
}
